import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-content">
        <h2>Get In Touch</h2>
        <p>
          I&apos;m currently looking for any new opportunities. My inbox is
          always open. Whether you have a question or just want to say hi,
          I&apos;ll get back to you soon!
        </p>
        <a
          className="contact-btn"
          href="mailto:vikasmpawar07@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Say Hello
        </a>
      </div>
      <div className="bottom-text">
        Built by{" "}
        <a
          href="https://github.com/vikasp07"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vikas Pawar
        </a>
      </div>
    </section>
  );
}

export default Contact;
